import React, { useRef, useEffect, useState } from 'react';

import i18n from '@nextroll/ar-i18n';

import { WorkflowAction, WorkflowActionService } from 'types/roflWorkflowActions';
import { SERVICES } from 'util/services.constants';
import { isFeatureFlagEnabled, RW_WORKFLOWS_EMAIL_NOTIFICATION } from 'util/featureFlags';

import { NodeHeaderSection } from 'components/basic/NodeHeaderSection/NodeHeaderSection';


export interface IActionNodePanelProps {
    workflowActionServices: WorkflowActionService[];
    presetWorkflowAction?: WorkflowAction;
    setWorkflowActionService: React.Dispatch<React.SetStateAction<WorkflowActionService | undefined>>;
    setWorkflowAction: React.Dispatch<React.SetStateAction<WorkflowAction | undefined>>;
    onClose?: () => void;
}

export const ActionNodePanel = (props: IActionNodePanelProps) => {
    const {
        workflowActionServices, presetWorkflowAction,
        setWorkflowAction, setWorkflowActionService, onClose,
    } = props;

    const [selectedWorkflowAction, setSelectedWorkflowAction]
        = useState<WorkflowAction | undefined>(presetWorkflowAction);
    const element = useRef<HTMLDivElement>(null);

    // setup handler to listen for "X" button to close the panel
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => event.code === 'KeyX' && onClose?.();
        if (element?.current) {
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [onClose]);

    return (
        <div tabIndex={-1} ref={element}>
            {i18n.gettext('Select one action')}

            {workflowActionServices.map(service => {
                if (service.service_name === 'rollworks' && !isFeatureFlagEnabled(RW_WORKFLOWS_EMAIL_NOTIFICATION)) {
                    return null; // don't show the email action without the feature flag
                }
                return (
                    <React.Fragment key={service.service_name}>
                        <NodeHeaderSection
                            icon={SERVICES?.[service.service_name]?.icon}
                            serviceTitle={service.service_display_name}
                            heading=''
                            className='workflow-node-panel-workflow-action-header-container'
                        />
                        {service.workflow_actions.filter(w => !w.depends_on).map(action => (
                            <div key={`workflow-action-section-${action.eid}`}>
                                <input
                                    type='radio'
                                    id={`workflow-action-${action.eid}-radio-button`}
                                    className='ar-radio-button'
                                    name='serviceWorkflowActionSelection'
                                    checked={selectedWorkflowAction?.eid === action.eid}
                                    value={action.eid}
                                    onChange={() => {
                                        setWorkflowAction(action);
                                        setWorkflowActionService(service);
                                        setSelectedWorkflowAction(action);
                                    }}
                                />
                                <label htmlFor={`workflow-action-${action.eid}-radio-button`}>
                                    {action.display_name}
                                </label>
                            </div>
                        ))}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
